// extracted by mini-css-extract-plugin
export var button = "_8f-0";
export var icon = "_8f-1";